import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { SuperSaleGroupCounterComponent } from '../report/super-sale-group-counter/super-sale-group-counter.component';
import { SuperSaleGroupOnlineComponent } from '../report/super-sale-group-online/super-sale-group-online.component';
import { SuperSaleGroupWalletComponent } from '../report/super-sale-group-wallet/super-sale-group-wallet.component';
import { SuperSaleGroupProductComponent } from '../report/super-sale-group-product/super-sale-group-product.component';

@Component({
  selector: 'app-super-sale-group',
  templateUrl: './super-sale-group.component.html',
  styleUrls: ['./super-sale-group.component.scss']
})
export class SuperSaleGroupComponent implements OnInit {
  from_date: any;
  to_date: any;
  is_document_available: boolean = true;
  document_data: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  selected_business_type_ids = [];
  booth_types: any;
  constructor(private global: GlobalService, private httpService: HttpService, private dialog: MatDialog) {
    this.title = this.global._active_display_name;
    this.httpService.getBoothTypes().subscribe((data) => {
      console.log(data);
      this.booth_types = data;
    }, (error) => {
      console.error(error);
    });
    // window.onscroll = () => {
    //   this.scrollCalled();
    // };
  }

  // scrollCalled() {
  //   console.log('scrolling');
  //   let header = document.getElementById("myHeader");
  //   let sticky = header.offsetTop;
  //   if (window.pageYOffset > sticky) {
  //     header.classList.add("sticky");
  //   } else {
  //     header.classList.remove("sticky");
  //   }
  // }

  counterReportCalled(business_code, from_date, to_date) {
    const dialogRef = this.dialog.open(SuperSaleGroupCounterComponent, {
      height: '394px',
      width: '600px',
      data: {
        'business_code': business_code,
        'from_date': from_date,
        'to_date': to_date,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        console.log(res);
      }
    });
  }

  depositAmountCalled(business_code, from_date, to_date) {

  }

  onlineReportCalled(business_code, from_date, to_date) {
    const dialogRef = this.dialog.open(SuperSaleGroupOnlineComponent, {
      height: '394px',
      width: '600px',
      data: {
        'business_code': business_code,
        'from_date': from_date,
        'to_date': to_date,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        console.log(res);
      }
    });
  }

  walletReportCalled(business_code, from_date, to_date) {
    const dialogRef = this.dialog.open(SuperSaleGroupWalletComponent, {
      height: '394px',
      width: '600px',
      data: {
        'business_code': business_code,
        'from_date': from_date,
        'to_date': to_date,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        console.log(res);
      }
    });
  }

  ProductReportCalled(business_code, from_date, to_date) {
    const dialogRef = this.dialog.open(SuperSaleGroupProductComponent, {
      height: '394px',
      width: '900px',
      position: { right : '230px'},
      data: {
        'business_code': business_code,
        'from_date': from_date,
        'to_date': to_date,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        console.log(res);
      }
    });
  }


  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'selected_business_type_ids': this.selected_business_type_ids
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveSuperSaleGroup(data_dict).subscribe((data) => {
      console.log(data);
      this.document_data = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/octet-stream;base64,' + this.document_data['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_data['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_data = null;
  }

  ngOnInit() {
  }

}
